import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import SuccessProcess from '../../components/Notifications/SuccessProcess';
import Loader from "../../components/Loader";
import Select from "react-select";
import apiClient from "../../axios";
import '../DeleteModal/DeleteModal.css';

const AddModulePack = ({ isVisible, onClose, element }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [moduleData, setModuleData] = useState([]);
    const [contractTypeId, setContTypeId] = useState("");
    const [mainModuleTemplateId, setMainModuleTemplateId] = useState("");
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [errorsMessage, setErrorMessage] = useState({});
    const [isLoginVisible, setIsLoginVisible] = useState(false);
    const [moduleSearch, setModuleSearch] = useState("");
    const [searchTerm, setSearchTerm] = useState('');
    const [notificationBlock, setNotificationBlock] = useState(false);
    const [messageBlock, setMessageBlock] = useState(false);

    useEffect(() => {
        if (element) {
            const fetchModuleId = async () => {
                try {
                    setLoading(true);
                    const response = await apiClient.get(`/product_type/${element.id}`);
                    setContTypeId(element.id);
                    setMainModuleTemplateId(response.data.mainModuleTemplateId);
                } catch (error) {
                    console.error("Error al cargar el mainModuleTemplateId", error);
                } finally {
                    setLoading(false);
                }
            };
            fetchModuleId();
            const fetchModulePackProd = async () => {
                try {
                    setLoading(true);

                    const params = new URLSearchParams();
                    if (searchTerm) params.append('search', searchTerm);

                    const modulo = await apiClient.get(`/module_pack/product/${element.id}?${params.toString()}`);
                    if (modulo.status === 200) {
                        setModuleData(modulo.data || []);
                    }
                } catch (error) {
                    console.error("Error al cargar los módulos", error);
                } finally {
                    setLoading(false);
                }
            };
            fetchModulePackProd();
        }
    }, [element, searchTerm]);

    const handleModulePackChange = (selectedOption) => {
        if (selectedOption) {
            setMainModuleTemplateId(selectedOption.value);
            setModuleSearch(selectedOption.label);
        } else {
            setMainModuleTemplateId("");
            setModuleSearch("");
        }
    };

    const handleCloseBlock = () => {
        setNotificationBlock(false);
    };
    const handleSave = async () => {
        try {
            let response;
            setLoading(true);
            const payloadUpdate = {
                contractTypeId,
                mainModuleTemplateId
            };
            response = await apiClient.patch(`/product_type/${element.id}`, payloadUpdate);
            if (response.status === 200) {
                setIsSuccessVisible(true);
                setIsErrorVisible(false);
                setIsLoginVisible(false);
                setTimeout(() => {
                    onClose();
                    navigate("/ProductTypeList");
                }, 1000);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            } else if (error.response?.data?.message.startsWith("PRODUCT_TYPE_ALREADY_EXIST")) {
                setMessageBlock(`El Tipo de Producto ingresado ya existe.`)
                setNotificationBlock(true);
            } else {
                setErrorMessage("¡Oops! Ocurrio un error al crear el Tipo de Producto");
                setIsLoginVisible(false);
                setIsErrorVisible(true);
                setIsSuccessVisible(false);
                setTimeout(() => {
                    setIsErrorVisible(false);
                }, 4000);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        isVisible && (
            <div className="info-notification-info-overlay">
                <div className="info-notification-info-mp-del">
                    <div className="message-container-info">
                        <h3 className="basic-info-form-title">Información del Tipo de Producto</h3>
                    </div>
                    <div className="message-container-info">
                        <div className="basic-info-form-group-add">
                            <label>Designación de Módulo</label>
                            {/*<select className="module-list"
                                value={mainModuleTemplateId}
                                onChange={(e) => {
                                    const selectedId = e.target.value;
                                    setMainModuleTemplateId(selectedId);}
                                }
                            >
                                <option value="">Seleccione una opción</option>
                                {module.map((mod) => (
                                    <option key={mod.id} value={mod.id}>
                                        {mod.modulo}
                                    </option>
                                ))}
                            </select>*/}
                            <Select
                                inputValue={searchTerm}
                                onInputChange={(val) => setSearchTerm(val)}
                                value={
                                    mainModuleTemplateId
                                        ? {
                                            value: mainModuleTemplateId,
                                            label: moduleSearch
                                        }
                                        : null
                                }
                                onChange={handleModulePackChange}
                                options={moduleData.map((m) => ({
                                    value: m.id,
                                    label: m.modulo,
                                }))}
                                placeholder="Seleccione un Módulo"
                                isClearable
                                classNamePrefix="custom-select"
                                className="custom-select-container"
                            />
                        </div>
                    </div>
                    <div className="button-container-info">
                        <button className="cancel-btn-info" onClick={onClose}>
                            Cancelar
                        </button>
                        <button className="ok-btn-info" onClick={handleSave}>
                            OK
                        </button>
                    </div>
                    <SuccessNotification
                        message={"El Tipo de Producto se ha Actualizado Correctamente."}
                        isVisible={isSuccessVisible}
                        onClose={() => setIsSuccessVisible(false)}
                    />
                    <ErrorNotification
                        message={errorsMessage}
                        isVisible={isErrorVisible}
                        onClose={() => setIsErrorVisible(false)}
                    />
                    <LoginNotification
                        message="Vuelve a iniciar sesión"
                        isVisible={isLoginVisible}
                        onClose={() => setIsLoginVisible(false)}
                    />
                    {notificationBlock && (
                        <SuccessProcess
                            enca={true}
                            message={`No se puede Añadir el Tipo de Producto debido a : ${messageBlock}`}
                            isVisible={notificationBlock}
                            onClose={handleCloseBlock}
                            redirectOnOk={true}
                            pageNavigate={"/Customers"}
                            whatsApp={false}
                        />
                    )}
                    {loading && <Loader />}
                </div>
            </div>
        )
    );
};

export default AddModulePack;
